module.exports = __webpack_public_path__ + "static/img/RAC188_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RAC188_1.png
// module id = ZjhM
// module chunks = 0